import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const export_excel = (dataToExport) => {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(dataToExport);

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Alumnos Filtrados');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'estado_cuotas.xlsx');
  };

export const handle_export = (filtered) => {
    try {
      filtered && export_excel(filtered); // Exportar solo los filtrados
    } catch (error) {
      console.error(error);
    }
  };